import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-location-tpams.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-location-tpams.component.scss?ngResource";
import { ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { CreateApplicationLocationTpamsConstants } from "./create-application-location-tpams.constants";
import { CRUDOperation } from "../../../../shared/models/crud-operation-enum.model";
import { AppControllerService } from "../../../../app-controller.service";
import { AlertType } from "../../../../shared/models/alert";
import Query from "@arcgis/core/rest/support/Query";
import { RequestStatusService } from "../../../../shared/services/request-status/request-status.service";
import { MapService } from "../../../../map/shared/map.service";
import { MapServiceConstants } from "../../../../map/map-service.constants";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import * as JsonUtils from "@arcgis/core/geometry/support/jsonUtils";
import { ApiModuleConstants } from "../../../../shared/constants/api-constants/api-module.constants";
import { WktConverterUtils } from "../../../../shared/utils/wkt-converter-utils";
import { CreateApplicationUtils } from "../../../shared/utils/create-application-utils";
import { MapTools } from "../../../../map/shared/map.tools";
export let CreateApplicationLocationTpamsComponent = class CreateApplicationLocationTpamsComponent extends CreateApplicationViewBaseComponent {
    applicationCreateService;
    mapTools;
    aflaModuleStrategyService;
    selectedApplicationService;
    appController;
    mapService;
    requestStatusService;
    changeDetectorRefs;
    active;
    propertiesForm;
    descriptionLabel1 = CreateApplicationLocationTpamsConstants.DESCRIPTION_LABEL_1;
    descriptionLabel2 = CreateApplicationLocationTpamsConstants.DESCRIPTION_LABEL_2;
    descriptionLabel3 = CreateApplicationLocationTpamsConstants.DESCRIPTION_LABEL_3;
    descriptionLabel4 = CreateApplicationLocationTpamsConstants.DESCRIPTION_LABEL_4;
    validationMessages = CreateApplicationLocationTpamsConstants.VALIDATION_MESSAGES;
    erfNoControl = CreateApplicationLocationTpamsConstants.ERF_NO_CONTROL;
    subdivisionControl = CreateApplicationLocationTpamsConstants.SUBDIVISION_CONTROL;
    allotmentControl = CreateApplicationLocationTpamsConstants.ALLOTMENT_CONTROL;
    farmNoControl = CreateApplicationLocationTpamsConstants.FARM_NO_CONTROL;
    sgCodeControl = CreateApplicationLocationTpamsConstants.SG_CODE_CONTROL;
    addressControl = CreateApplicationLocationTpamsConstants.ADDRESS_CONTROL;
    buildingUseControl = CreateApplicationLocationTpamsConstants.BUILDING_USE_CONTROL;
    erfSizeControl = CreateApplicationLocationTpamsConstants.ERF_SIZE_CONTROL;
    buildingFloorAreaControl = CreateApplicationLocationTpamsConstants.BUILDING_FLOOR_AREA_CONTROL;
    totalValueControl = CreateApplicationLocationTpamsConstants.TOTAL_VALUE_CONTROL;
    titleDeedControl = CreateApplicationLocationTpamsConstants.TITLE_DEED_CONTROL;
    zoneControl = CreateApplicationLocationTpamsConstants.ZONE_CONTROL;
    ownerControl = CreateApplicationLocationTpamsConstants.OWNER_CONTROL;
    erfNoTextPlaceHolder = CreateApplicationLocationTpamsConstants.ERF_NO_TEXT_PLACEHOLDER;
    subdivisionTextPlaceHolder = CreateApplicationLocationTpamsConstants.SUBDIVISION_TEXT_PLACEHOLDER;
    allotmentTextPlaceHolder = CreateApplicationLocationTpamsConstants.ALLOTMENT_TEXT_PLACEHOLDER;
    farmNoTextPlaceHolder = CreateApplicationLocationTpamsConstants.FARM_NO_TEXT_PLACEHOLDER;
    sgCodeTextPlaceHolder = CreateApplicationLocationTpamsConstants.SG_CODE_TEXT_PLACEHOLDER;
    addressTextPlaceHolder = CreateApplicationLocationTpamsConstants.ADDRESS_TEXT_PLACEHOLDER;
    buildingUseTextPlaceHolder = CreateApplicationLocationTpamsConstants.BUILDING_USE_TEXT_PLACEHOLDER;
    erfSizeTextPlaceHolder = CreateApplicationLocationTpamsConstants.ERF_SIZE_TEXT_PLACEHOLDER;
    buildingFloorAreaTextPlaceHolder = CreateApplicationLocationTpamsConstants.BUILDING_FLOOR_AREA_TEXT_PLACEHOLDER;
    totalValueTextPlaceHolder = CreateApplicationLocationTpamsConstants.TOTAL_VALUE_TEXT_PLACEHOLDER;
    titleDeedTextPlaceHolder = CreateApplicationLocationTpamsConstants.TITLE_DEED_TEXT_PLACEHOLDER;
    zoneLabel = CreateApplicationLocationTpamsConstants.ZONE_LABEL;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    removeLabel = SharedConstants.REMOVE_LABEL;
    addZoneLabel = CreateApplicationLocationTpamsConstants.ADD_ZONE_LABEL;
    copyApplicantToOwnerZoneLabel = CreateApplicationLocationTpamsConstants.COPY_APPLICANT_TO_OWNER_LABEL;
    removePropertyLabel = CreateApplicationLocationTpamsConstants.REMOVE_PROPERTY_LABEL;
    ownerLabel = CreateApplicationLocationTpamsConstants.OWNER_LABEL;
    layerReference = CreateApplicationLocationTpamsConstants.LAYER_REF;
    ownerDisableFilterBy = true;
    ownerDisableAdd = false;
    ownerDisableEditing = false;
    ownerShowGroupsDropdown = true;
    ownerGroups = [];
    ownerListLabel = "Owner";
    zones = [];
    fullApplicationCheckRequired = true;
    showOnlyPropertyAndZoningLayers = false;
    missingZoneList = new Map();
    subdivisionControlRequired = true;
    farmNoControlRequired = true;
    erfNoControlRequired = true;
    mapComponent;
    isMapLoaded = false;
    hasLoadedApplicationProperties = false;
    missingZoneTuple;
    constructor(applicationCreateService, mapTools, aflaModuleStrategyService, selectedApplicationService, appController, mapService, requestStatusService, changeDetectorRefs) {
        super(applicationCreateService, aflaModuleStrategyService, selectedApplicationService);
        this.applicationCreateService = applicationCreateService;
        this.mapTools = mapTools;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.appController = appController;
        this.mapService = mapService;
        this.requestStatusService = requestStatusService;
        this.changeDetectorRefs = changeDetectorRefs;
    }
    get getProperties() {
        return this.propertiesForm.get("properties");
    }
    ngOnInit() {
        this.checkAndInitialiseLookups();
        this.initForm();
        this.getMetadata();
        this.subscribeToProperty();
        this.setupSubscribers();
        this.changeDetectorRefs.detectChanges();
    }
    ngAfterViewInit() {
        this.mapService.actionPropertyEnabled = true;
    }
    mapLoaded() {
        this.isMapLoaded = true;
        this.syncMapGeometries();
    }
    ngOnDestroy() {
        this.mapService.destroyMap();
        super.ngOnDestroy();
    }
    loadMetadata(stepMeta) {
        this.ownerGroups = stepMeta.ownerGroup;
        this.changeDetectorRefs.markForCheck();
    }
    getZones(propertyIndex) {
        return this.getProperties.controls[propertyIndex].get("zones");
    }
    onBtnRemoveZoneClicked(propertyIndex, zoneIndex) {
        const controls = this.getZones(propertyIndex);
        if (controls.controls.length > 1) {
            controls.removeAt(zoneIndex);
        }
    }
    onBtnAddZoneClicked(propertyIndex) {
        const zonesControl = this.getZones(propertyIndex);
        const zoneGroup = new FormGroup({
            zone: new FormControl(null, [Validators.required])
        });
        zonesControl.push(zoneGroup);
    }
    onBtnRemovePropertyClicked(propertyIndex) {
        this.getProperties.removeAt(propertyIndex);
        this.syncMapGeometries();
        this.changeDetectorRefs.detectChanges();
    }
    getMissingZones(index) {
        if (this.missingZoneList && this.missingZoneList.size > 0) {
            // send email to module admin if it has not already been sent
            this.missingZoneTuple = this.missingZoneList.get(index);
            if (this.missingZoneTuple[1] === false) {
                this.sendEmailMissingLookupForZones(this.missingZoneTuple[0]);
                this.missingZoneTuple = [this.missingZoneTuple[0], true];
                this.missingZoneList.set(index, this.missingZoneTuple);
            }
            let zones = "";
            let count = 1;
            this.missingZoneTuple[0].forEach((zone) => {
                zones += zone + (count < zone.length ? "|" : "");
                count++;
            });
            return `${CreateApplicationLocationTpamsConstants.MISSING_ZONE_LABEL} ${zones} ${CreateApplicationLocationTpamsConstants.MISSING_ZONE_LABEL_EMAIL}`;
        }
    }
    updatePropertyRequiredFields(newProperty) {
        const erfNoControl = newProperty.get(this.erfNoControl);
        const farmNoControl = newProperty.get(this.farmNoControl);
        const subdivisionControl = newProperty.get(this.subdivisionControl);
        if (erfNoControl.value !== undefined && erfNoControl.value !== null && erfNoControl.value.trim() !== "") {
            erfNoControl.setValidators(Validators.required);
            farmNoControl.clearValidators();
            subdivisionControl.clearValidators();
            farmNoControl.setValue("");
            subdivisionControl.setValue("");
            farmNoControl.disable();
            subdivisionControl.disable();
            subdivisionControl.markAsUntouched();
            farmNoControl.markAsUntouched();
            this.subdivisionControlRequired = false;
            this.farmNoControlRequired = false;
            this.erfNoControlRequired = true;
        }
        else if ((farmNoControl.value !== undefined && farmNoControl.value !== null && farmNoControl.value.trim() !== "") ||
            (subdivisionControl.value !== undefined && subdivisionControl.value !== null && subdivisionControl.value.trim() !== "")) {
            farmNoControl.setValidators(Validators.required);
            subdivisionControl.setValidators(Validators.required);
            erfNoControl.clearValidators();
            erfNoControl.setValue("");
            erfNoControl.disable();
            erfNoControl.markAsUntouched();
            this.subdivisionControlRequired = true;
            this.farmNoControlRequired = true;
            this.erfNoControlRequired = false;
        }
        else {
            erfNoControl.setValidators(Validators.required);
            farmNoControl.setValidators(Validators.required);
            subdivisionControl.setValidators(Validators.required);
            erfNoControl.enable();
            farmNoControl.enable();
            subdivisionControl.enable();
            erfNoControl.markAsUntouched();
            subdivisionControl.markAsUntouched();
            farmNoControl.markAsUntouched();
            this.subdivisionControlRequired = true;
            this.farmNoControlRequired = true;
            this.erfNoControlRequired = true;
        }
        erfNoControl.updateValueAndValidity();
        farmNoControl.updateValueAndValidity();
        subdivisionControl.updateValueAndValidity();
        this.changeDetectorRefs.detectChanges();
    }
    setNumberToDecimal(formControl, event) {
        // sets number to two decimal places
        const value = event.target.value;
        const decimalValue = parseFloat(value).toFixed(2);
        formControl.setValue(decimalValue);
    }
    initForm() {
        this.propertiesForm = this.aflaModuleStrategyService.form.get("propertiesForm");
    }
    getLookups() {
        const params = {
            $filter: `moduleId eq ${this.applicationCreateService.moduleID} and name eq 'Zoning'`,
        };
        this.applicationCreateService.getLookupsObservable(params).subscribe({
            next: (lookupResponse) => this.onGetLookupsCompleted(lookupResponse),
            error: (error) => {
                this.appController.handleServerErrorMessage(CreateApplicationLocationTpamsConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onGetLookupsCompleted(response) {
        const zones = [];
        if (response && response.value.length > 0) {
            response.value.forEach(item => {
                if (item.name === "Zoning") {
                    zones.push(JSON.parse(item.content));
                }
            });
        }
        this.aflaModuleStrategyService.lookups.set("zones", zones);
        this.zones = zones;
        this.sortZones();
        this.applicationCreateService.setHasLoadedLookups(true);
        this.changeDetectorRefs.detectChanges();
    }
    setPropertyAttributes(propertyAttributes, geometry) {
        this.requestStatusService.showBusySpinner("GetPropertyData");
        try {
            const sgCode = CreateApplicationUtils.propertyDataAlternateColumnName(propertyAttributes, "SgCode", "sgCode");
            const duplicateFound = CreateApplicationUtils.checkIfPropertyIsADuplicate(sgCode, this.getProperties, this.appController, this.requestStatusService);
            if (!duplicateFound) {
                const newPropertyFormGroup = CreateApplicationUtils.createNewPropertyFormGroup(propertyAttributes, sgCode, geometry);
                this.applicationCreateService.getPropertyCentroidObservable(geometry).subscribe({
                    next: (trueCentroidResponse) => {
                        CreateApplicationUtils.handleTrueCentroidResponse(trueCentroidResponse, newPropertyFormGroup);
                        this.queryZoningLayer(sgCode, newPropertyFormGroup);
                    },
                    error: (error) => {
                        this.requestStatusService.removeBusySpinner("GetPropertyDate");
                        this.appController.handleServerErrorMessage(CreateApplicationLocationTpamsConstants.TRUE_CENTROID, error, CRUDOperation.Get);
                    }
                });
            }
        }
        catch (e) {
            this.appController.handleServerErrorMessage("getTrueCentroid", e, CRUDOperation.Get);
            this.requestStatusService.showBusySpinner("GetPropertyData");
        }
    }
    syncMapGeometries() {
        const geometries = [];
        this.getProperties.controls.forEach(propertyControl => {
            const geom = propertyControl.get("geometry").value;
            if (geom) {
                geometries.push(geom);
            }
        });
        if (geometries.length > 0) {
            this.mapComponent.addGeometriesOnMap(geometries, "Town planning graphics", true);
        }
        else {
            this.mapComponent.removeGraphicsFromMap("Town planning graphics");
        }
    }
    subscribeToProperty() {
        this.cleanupAfterDestroy(this.mapService.$selectedProperty).subscribe(propertyData => {
            if (propertyData !== null) {
                this.setPropertyAttributes(propertyData.attributes, propertyData.geometry);
            }
        });
    }
    sendEmailMissingLookupForZones(missingLookupsForZones) {
        const url = `${ApiModuleConstants.URL}/${ApiModuleConstants.MISSING_LOOKUP_EMAIL_REQUEST_URL}`;
        const params = {
            moduleId: this.applicationCreateService.moduleID, lookupType: "Zoning", lookupList: missingLookupsForZones
        };
        this.cleanupAfterDestroy(this.applicationCreateService.sendMissingLookupsEmail(url, params))
            .subscribe({
            next: () => {
            },
            error: (error) => {
                this.appController.handleServerErrorMessage(`${CreateApplicationLocationTpamsConstants.MISSING_ZONE_LABEL_EMAIL_FAILED}`, error, CRUDOperation.Selecting);
            }
        });
    }
    subscribeToClearGraphics() {
        this.applicationCreateService.$clearLayerGraphicsSubject.subscribe({
            next: (clearGraphics) => {
                if (clearGraphics) {
                    this.getProperties.clear();
                    this.mapComponent.removeGraphicsFromMap(this.layerReference);
                    this.mapTools.sketchGraphicsLayer.removeAll();
                    this.changeDetectorRefs.detectChanges();
                }
            }
        });
    }
    sortZones() {
        // sort zones dropdown alphabetically
        this.zones?.sort((a, b) => (a.value?.localeCompare(b?.value)));
    }
    queryZoningLayer(sgCode, newPropertyFormGroup) {
        const zoningLayerObj = this.mapService.userMaps.find(a => a.selectionLayerType === MapServiceConstants.PROPERTY_ZONING_LAYER);
        if (zoningLayerObj !== undefined && zoningLayerObj !== null) {
            const zoningLayer = zoningLayerObj.layer;
            const zoningQuery = new Query();
            zoningQuery.where = `SgCode = '${sgCode}'`;
            zoningQuery.returnGeometry = false;
            zoningQuery.outFields = ["*"];
            zoningLayer.queryFeatures(zoningQuery).then((zoneFeatureSet) => {
                this.handleResponseAfterQueryingPropertyZoningFeatures(newPropertyFormGroup, zoneFeatureSet);
                this.setPropertyTabs(newPropertyFormGroup);
                this.syncMapGeometries();
                this.requestStatusService.removeBusySpinner("GetPropertyDate");
            }, (zoningError) => {
                this.appController.showMessage(zoningError.message, AlertType.Error);
                this.setPropertyTabs(newPropertyFormGroup);
                this.syncMapGeometries();
                this.requestStatusService.removeBusySpinner("GetPropertyDate");
            });
            this.updatePropertyRequiredFields(newPropertyFormGroup);
            this.sortZones();
        }
        else {
            const zonesControl = newPropertyFormGroup.get("zones");
            zonesControl.push(new FormGroup({
                zone: new FormControl(null, [Validators.required])
            }));
            this.updatePropertyRequiredFields(newPropertyFormGroup);
            this.setPropertyTabs(newPropertyFormGroup);
            this.syncMapGeometries();
            this.requestStatusService.removeBusySpinner("GetPropertyDate");
        }
    }
    handleResponseAfterQueryingPropertyZoningFeatures(newPropertyFormGroup, zoneFeatureSet) {
        const zonesControl = newPropertyFormGroup.get("zones");
        if (zoneFeatureSet.features.length > 0) {
            zoneFeatureSet.features.forEach(item => {
                const zone = CreateApplicationUtils.propertyDataAlternateColumnName(item.attributes, "Zoning", "zoning");
                if (zone !== undefined && zone != null) {
                    let foundZone = null;
                    this.zones.forEach(zoneItem => {
                        if (zoneItem.value === zone) {
                            foundZone = zoneItem;
                        }
                    });
                    if (foundZone !== null) {
                        zonesControl.push(new FormGroup({
                            zone: new FormControl(foundZone, [Validators.required])
                        }));
                    }
                    else {
                        this.appController.showMessage(CreateApplicationLocationTpamsConstants.ZONING_NOT_FOUND.replace("{0}", zone), AlertType.Warning);
                    }
                }
                else {
                    this.appController.showMessage(CreateApplicationLocationTpamsConstants.INVALID_ZONING_ATTRIBUTE, AlertType.Error);
                }
            });
        }
        if (zonesControl.length === 0) {
            zonesControl.push(new FormGroup({
                zone: new FormControl(null, [Validators.required])
            }));
        }
    }
    setPropertyTabs(newPropertyFormGroup) {
        const propertyControl = this.getProperties;
        propertyControl.push(newPropertyFormGroup);
        this.active = propertyControl.length - 1;
        this.changeDetectorRefs.detectChanges();
    }
    subscribeToSelectedApplication() {
        this.cleanupAfterDestroy(this.selectedApplicationService.$selectedApplication).subscribe((application) => {
            this.selectedApplication = +this.jobId > 0 && application ? application : null;
            if (this.selectedApplication) {
                this.updateComponentData();
            }
        });
    }
    setupSubscribers() {
        this.subscribeToClearGraphics();
        this.subscribeToSelectedApplication();
    }
    updateComponentData() {
        if (+this.jobId > 0 && this.selectedApplication) {
            const propertyControl = this.clearPropertyData();
            let tabIndex = 0;
            this.selectedApplication.properties.sort((a, b) => (b?.id - a?.id));
            this.selectedApplication.properties.forEach(savedProperty => {
                const geometryArc = WktConverterUtils.ConvertWktToArcGisJson(savedProperty.shape, 102100);
                const geom = JsonUtils.fromJSON(geometryArc);
                const newPropertyFormGroup = CreateApplicationUtils.getUpdatedPropertyFormGroup(savedProperty, geom);
                this.propertiesForm.markAllAsTouched();
                this.updateZoneDropdown(newPropertyFormGroup, savedProperty, tabIndex);
                this.applicationCreateService.getPropertyCentroidObservable(geom).subscribe({
                    next: (trueCentroidResponse) => {
                        CreateApplicationUtils.handleTrueCentroidResponse(trueCentroidResponse, newPropertyFormGroup);
                        propertyControl.push(newPropertyFormGroup);
                        this.active = propertyControl.length - 1;
                        this.syncMapGeometries();
                        CreateApplicationUtils.updatePropertyIds(this.selectedApplication, this.propertiesForm);
                        this.updatePropertyRequiredFields(newPropertyFormGroup);
                        this.changeDetectorRefs.detectChanges();
                    },
                    error: (error) => {
                        this.appController.handleServerErrorMessage(CreateApplicationLocationTpamsConstants.TRUE_CENTROID, error, CRUDOperation.Get);
                    }
                });
                tabIndex++;
            });
            if (this.isMapLoaded) {
                this.syncMapGeometries();
            }
            this.hasLoadedApplicationProperties = true;
            this.changeDetectorRefs.detectChanges();
        }
    }
    clearPropertyData() {
        this.missingZoneList = new Map();
        this.applicationCreateService.$missingLookupsForZones = [];
        const propertyControl = this.getProperties;
        propertyControl.clear();
        return propertyControl;
    }
    updateZoneDropdown(newPropertyFormGroup, savedProperty, tabIndex) {
        const missingLookupsForZones = [];
        const zonesControl = newPropertyFormGroup.get("zones");
        savedProperty.zonings.forEach(zone => {
            let foundZone = false;
            this.zones.forEach(zoneOption => {
                if (zoneOption.value === zone.zoning) {
                    foundZone = true;
                    const zoneGroup = new FormGroup({
                        id: new FormControl(zone.id),
                        applicationId: new FormControl(zone.applicationId),
                        applicationPropertyId: new FormControl(zone.applicationPropertyId),
                        zone: new FormControl(zoneOption, [Validators.required]),
                        deleted: new FormControl(zone.deleted)
                    });
                    zonesControl.push(zoneGroup);
                }
            });
            this.zones?.sort((a, b) => (a.value?.localeCompare(b?.value)));
            if (!foundZone) {
                missingLookupsForZones.push(zone.zoning);
                this.applicationCreateService.$missingLookupsForZones.push(zone.zoning);
            }
        });
        if (missingLookupsForZones.length > 0) {
            this.missingZoneTuple = [missingLookupsForZones, false];
            this.missingZoneList.set(tabIndex, this.missingZoneTuple);
        }
    }
    checkAndInitialiseLookups() {
        this.hasLoadedApplicationProperties = false;
        this.applicationCreateService.setHasLoadedLookups(false);
        this.selectedApplicationService.$applicationSavedSubject.next(false);
        if (this.aflaModuleStrategyService.lookups.has("zones")) {
            this.zones = this.aflaModuleStrategyService.lookups.get("zones");
            this.sortZones();
            this.applicationCreateService.setHasLoadedLookups(true);
        }
        else {
            this.getLookups();
        }
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: MapTools },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: AppControllerService },
        { type: MapService },
        { type: RequestStatusService },
        { type: ChangeDetectorRef }
    ];
    static propDecorators = {
        mapComponent: [{ type: ViewChild, args: ["esriMap", { static: true },] }]
    };
};
CreateApplicationLocationTpamsComponent = __decorate([
    Component({
        selector: "app-create-application-location-tpams",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CreateApplicationLocationTpamsComponent);
